<div id='ZN_5hGGKDRdqgaGLKm'></div> 
<p-toast baseZIndex="10000"></p-toast>

<div class="container-etracking">
  <p-card>    
    <div class="p-grid" style="margin-bottom: -60px;">
      <div class="p-col-12 p-md-12 p-lg-12">
        <iframe id="Iframe" frameborder="0px" width="100%" height="600px"></iframe>
      </div>
      <div class="p-col-10 p-md-10 p-lg-10"></div>
      <div class="p-col-9 p-md-9 p-lg-11"></div>   
    </div> 
  </p-card>

  <br>

  <p-card >
    <div *ngIf="showPPQ" class="dataPPQ" style="margin-top: -10px; margin-bottom: -10px;">
      <div class="layer3">
        <div class="layer2">
          <div class="layer1">
            <hr>
            <div class="p-grid gridPPQ">
                <div *ngIf="showPPQStart" class="p-p-0 p-col-12 p-md-12 p-lg-1 check"><span class="badge-history"><i class="fa fa-check"></i></span></div>
                <div *ngIf="showPPQStart" class="p-p-0 p-col-12 p-md-12 p-lg-2"><h5 class="styleFontPPQ" style="margin-left: 8%;">PPQ Start</h5></div>

                <div *ngIf="showPPQStart" class="p-p-0 p-col-12 p-md-12 p-lg-2" style="margin-left: -1%;width: 30%;"><h5 class="styleFontPPQ">{{Tracking.flight}}|{{Tracking.ppqstarted | avDateTimeOffset:'OriginalLocationHourTime'}}|{{Tracking.route}}</h5></div>
                <div *ngIf="showPPQStart" class="p-p-0 p-col-12 p-md-12 p-lg-4" style="margin-left: -20%;"></div>
            </div>
          <br>
          <hr *ngIf="showPPQFinished">
            <div class="p-grid gridPPQ">    
              <div *ngIf="showPPQFinished" class="p-p-0 p-col-12 p-md-12 p-lg-1 check"><span class="badge-history"><i class="fa fa-check"></i></span></div>
              <div *ngIf="showPPQFinished" class="p-col-12 p-md-12 p-lg-2"><h5 class="styleFontPPQ">PPQ Finish</h5></div>
              <div *ngIf="showPPQFinished" class="p-col-12 p-md-12 p-lg-2" style="margin-left: -2%;width: 30%;"><h5 class="styleFontPPQ">{{Tracking.flight}}|{{Tracking.ppqfinished | avDateTimeOffset:'OriginalLocationHourTime'}}|{{Tracking.route}}</h5> </div>     
              <div *ngIf="showPPQFinished" class="p-col-12 p-md-12 p-lg-4" style="margin-left: -20%;"></div>
          </div>
          </div>
        </div>
      </div>  
    </div>
 
  </p-card>
</div>




<app-survey-qualtrics></app-survey-qualtrics>
